/* eslint-disable import/prefer-default-export */
import { useEffect } from 'react';
import { nanoid } from 'nanoid';
import { useQueryState } from 'nuqs';
import { queryStateParser, queryParam, backwardsCompatabilityFactory, QueryStateSchema } from './queryStateParser';

const QS_KEY = 'paneCreditReportId';
const QS_TYPE: QueryStateSchema['type'] = 'creditReport';

export const useOpenCreditReportPane = (): ((args: { creditReportId: string }) => void) => {
  const [creditReportIdDeprecated, setCreditReportId] = useQueryState(QS_KEY, { history: 'push' });
  const [__, setState] = useQueryState(queryParam, queryStateParser);

  useEffect(() => {
    if (creditReportIdDeprecated) {
      setCreditReportId(null);
      setState(backwardsCompatabilityFactory({ id: creditReportIdDeprecated, type: QS_TYPE }));
    }
  }, [creditReportIdDeprecated]);

  return ({ creditReportId }) => {
    setState(prevState => [...(prevState || []), {
      id: creditReportId,
      key: nanoid(),
      type: QS_TYPE,
    }]);
  };
};
